export function LogoMark({ size = 40 }) {
    return (
        <img
            src="/logo.png"
            alt="9CUT Hair Salon logo"
            width={size}
            height={size}
            className="rounded-full border border-[#FFB800]/40 object-cover shadow-[0_0_16px_rgba(255,184,0,0.25)]"
            style={{ width: size, height: size }}
        />
    );
}
